export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
            关于蘑菇影院
          </h2>
          <p className="text-foreground-500 text-sm md:text-base leading-relaxed max-w-3xl mx-auto">
            蘑菇影院创立于对影视热爱的初心，是一个完全免费的在线观影平台。我们聚合全网优质影视资源，涵盖电影、电视剧、综艺、动漫等多种类型。无需注册、无需付费，即点即看。平台每日更新最新热门内容，确保您第一时间看到想看的影片。高清画质搭配流畅播放体验，让每一位影迷都能在这里找到属于自己的观影乐趣。蘑菇影院免费在线观看，真正实现"好片不等待、看片不花钱"。
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-primary-500 font-heading">5万+</div>
              <div className="text-xs text-foreground-400 mt-1">影视资源</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-primary-500 font-heading">99%</div>
              <div className="text-xs text-foreground-400 mt-1">高清覆盖率</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-primary-500 font-heading">0元</div>
              <div className="text-xs text-foreground-400 mt-1">永久免费</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-primary-500 font-heading">24h</div>
              <div className="text-xs text-foreground-400 mt-1">全天候更新</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}